/* @flow */
/** ***********************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {Utils} from '../../../../../utils/Globals';
import './EmptyState.scss';
import {RecentAssetsAnalytics} from 'recent-files';
import {getEnvironment} from '../../../../../utils/Environment';
import {getLocalizedURL} from '@intl/adobe-locales';
import {newCanvasLinks} from '../../../../containers/AppHome/appHomeData';
/* eslint-enable no-unused-vars */

/*
 * FredEmptyState is the view displayed in the UI when empty(s) occur.
 */
class IllustratorEmptyState extends Component {
	componentDidMount() {
		this.addEventListenerToElemId('empty-state-illustrator-new-file', 'click', this.handleNewFileClick);
	}

	addEventListenerToElemId(elemId: string, eventType: string, callback: EventListenerOrEventListenerObject) {
		const elem = document.getElementById(elemId);
		if (elem) {
			elem.addEventListener(eventType, callback);
		}
	}

	handleNewFileClick = (e) => {
		e.preventDefault();
		const url = getLocalizedURL(newCanvasLinks[getEnvironment()].ILST);
		const analytics = new RecentAssetsAnalytics();
		const analyticsPromise = analytics.postEmptyPageClick('new-file', url);
		if (analyticsPromise && analyticsPromise.then) {
			analyticsPromise.then(() => window.open(url, '_self')).catch(() => window.open(url, '_self'));
		}
		else {
			window.open(url, '_self');
		}
	};

	render() {
		return (
			<div className='empty-state-app-home empty-state-fred-container' role='region'>
				<svg
					viewBox='0 0 199 97.7'
					height='110'
					className='spectrum-IllustratedMessage-illustration'
					aria-hidden='true'
				>
					<g fill='none' strokeLinecap='round' strokeLinejoin='round' strokeMiterlimit='10' strokeWidth='3px'>
						<path d='M110.53,85.66,100.26,95.89a1.09,1.09,0,0,1-1.52,0L88.47,85.66' />
						<line x1='99.5' y1='95.5' x2='99.5' y2='58.5' />
						<path d='M105.5,73.5h19a2,2,0,0,0,2-2v-43' />
						<path d='M126.5,22.5h-19a2,2,0,0,1-2-2V1.5h-31a2,2,0,0,0-2,2v68a2,2,0,0,0,2,2h19' />
						<line x1='105.5' y1='1.5' x2='126.5' y2='22.5' />
						<path d='M139.5,36.5H196A1.49,1.49,0,0,1,197.5,38V72A1.49,1.49,0,0,1,196,73.5H141A1.49,1.49,0,0,1,139.5,72V32A1.49,1.49,0,0,1,141,30.5H154a2.43,2.43,0,0,1,1.67.66l6,5.66' />
						<rect x='1.5' y='34.5' width='58' height='39' rx='2' ry='2' />
						<path strokeWidth='2px' d='M47.93,50.49a5,5,0,1,0-4.83-5A4.93,4.93,0,0,0,47.93,50.49Z' />
						<path strokeWidth='2px' d='M36.6,65.93,42.05,60A2.06,2.06,0,0,1,45,60l12.68,13.2' />
						<path strokeWidth='2px' d='M3.14,73.23,22.42,53.76a1.65,1.65,0,0,1,2.38,0l19.05,19.7' />
					</g>
				</svg>
				<h2
					className='empty-state-psweb-heading'
					dangerouslySetInnerHTML={{
						__html: Utils.localizedStrings['recents.illustrator.emptystate.heading'],
					}}
				/>
				<div
					className='empty-state-psweb-description'
					dangerouslySetInnerHTML={{
						__html: Utils.localizedStrings['recents.illustrator.emptystate.description'],
					}}
				/>
			</div>
		);
	}
}

export default IllustratorEmptyState;
